import React, { Children } from 'react';
import PropTypes from 'prop-types';

HighlightNote.propTypes = {
  children: PropTypes.node
};

export function HighlightNote(props) {
  const { children } = props;

  return (
    <span className="inline-block bg-cs-yellow-75 text-cs-gray-900 text-sm leading-5 rounded-md px-3 py-1.5">
      {children}
    </span>
  );
}

function Divider() {
  return <div className="h-px w-full bg-cs-gray-300" />;
}

ProjectDescription.propTypes = {
  kicker: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  summaryLabel: PropTypes.node.isRequired,
  summaryTitle: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  completed: PropTypes.node,
  children: PropTypes.node
};

export default function ProjectDescription(props) {
  const {
    kicker,
    title,
    summaryLabel,
    summaryTitle,
    description,
    completed,
    children
  } = props;

  return (
    <article className="w-full max-w-screen-xl mx-auto bg-white rounded-cs-10 shadow-lg overflow-hidden">
      {/* Header */}
      <header className="bg-cs-navy-600 px-4 py-5">
        <p className="text-white text-base leading-normal font-medium">{kicker}</p>
        <h2 className="mt-1 text-white text-3xl leading-tight font-extrabold">{title}</h2>
      </header>

      {/* Body — summary block */}
      <div className="px-4 pt-5 pb-6">
        <p className="text-cs-gray-900 text-sm leading-none font-medium">{summaryLabel}</p>
        <h3 className="mt-3 text-cs-gray-900 text-3xl leading-none font-bold">{summaryTitle}</h3>
        <p className="mt-4 text-cs-gray-900 text-base leading-5 font-normal">{description}</p>
        {completed}
      </div>

      {/* Rows — supplied by the consumer as ProjectDescriptionRow children */}
      <div className="flex flex-col">
        {!completed && Children.map(children, (child) => (
          <>
            <Divider />
            {child}
          </>
        ))}
      </div>
    </article>
  );
}
